/**
 * InsolationOnboarding — content for the Insolation mode onboarding panel.
 *
 * Pure presentational component: renders the title, body and dismiss button.
 * Visibility and sessionStorage persistence are handled by OnboardingContext /
 * OnboardingOverlay — this component only needs to call closeOnboarding() on dismiss.
 */
import { useState } from 'react'

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { InsolationMode }  from '../../../../shared/ui/icons/index.js'

import styles from './InsolationOnboarding.module.scss'
import pane_styles from './OnboardingOverlay.module.scss' // for shared styles like .title

export function InsolationOnboarding({isMobile, loadExpanded = false}) {
  const { t } = useI18n()
  const [expanded, setExpanded] = useState(loadExpanded)

  const ctaMessage = isMobile 
  ? t('product.insolation_onboarding_cta_mobile') 
  : t('product.insolation_onboarding_cta_desktop');

  return (
    <div className={pane_styles.content}>
      <span className={pane_styles.title}><InsolationMode /> {t('product.insolation_onboarding_title')}</span>
      {expanded && <p className={pane_styles.body}>{t('product.insolation_onboarding_par1')}</p>}
      {expanded && <p className={pane_styles.body}>{t('product.insolation_onboarding_par2')}</p>}
      <p className={pane_styles.cta}>{t('product.insolation_onboarding_cta_desktop')}</p>
      {expanded && <p className={pane_styles.disclaimer}>{t('product.insolation_onboarding_disclaimer')}</p>}
      <span
        className={pane_styles.cta}
        onClick={() => setExpanded((e) => !e)}
        style={{ cursor: 'pointer' }}
      >
        {expanded ? t('product.onboarding_hide_details') : t('product.onboarding_learn_more')}
      </span>
    </div>
  )
}


